module.exports = __webpack_public_path__ + "static/banner-footer-update-data-ar-MB-a5f91625fd6f84483ce3c90ec53c2338.png";